/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { IrrSaasConfig } from './irrSaasConfig';


export interface RegisterIrrSaasConfigSpec { 
    /**
     * IRR Config version
     */
    configVersion: string;
    serviceType: ServiceTypeEnum;
    irrFQDN: string;
    config: IrrSaasConfig;
}
export namespace RegisterIrrSaasConfigSpec {
}


